export default __webpack_public_path__ + "static/media/calendar3(a).56dae30a.png";